<template>
    <v-form lazy-validation class="" v-click-outside="none">
        <v-flex>
            <v-layout row wrap class="change-username">
                <v-flex class="alert__box__success" v-if="success">
                    <v-icon>check</v-icon> {{changeUserNameConstants.USERNAME_CHANGED_CONIFRMATION}}
                </v-flex>
                <v-flex class="alert__box__failure" v-if="error">
                    <v-icon>check</v-icon> {{changeUserNameConstants.USERNAME_WARNING}}
                </v-flex>
            </v-layout>
            <v-flex mb-3 mt-2>
                <v-flex class="username-label"> {{ changeUserNameConstants.CURRENT_USERNAME }} </v-flex>
                <small class="truncate" v-if="profileInformation && profileInformation.webLoginIdhistorical">
                    {{ profileInformation.webLoginIdhistorical }}
                </small>
            </v-flex>
            <v-flex>
                <v-flex :class="['username-label', validationError]"> {{ changeUserNameConstants.NEW_USERNAME }} </v-flex>
                <v-layout row wrap>
                    <v-flex xs10>
                        <v-text-field
                            id="new_username_input"
                            data-qe-id="new_username_input"
                            class="new-username cursor-text"
                            v-model="newUserName"
                            v-on:keypress="isValidUserName($event)"
                            @paste="isPasted($event)"
                            required
                            @focus="resetError">
                        </v-text-field>
                    </v-flex>
                    <v-flex xs2 class="icons__block">
                        <v-flex>
                            <v-flex :class="['value', isStrong]" tag="span" data-qe-id="username_charactersCount">{{counter}}</v-flex>
                            <v-icon :class="isStrong" data-qe-id="check_charactersCount">check</v-icon>
                        </v-flex>
                    </v-flex>
                </v-layout>
            </v-flex>
        </v-flex>
        <v-flex xs10 v-if="userExists">
            <div class="error-text"> {{changeUserNameConstants.USERNAME_EXISTS_ERROR}} </div>
        </v-flex>
        <v-flex xs10>
            <div class="warning-text"> {{changeUserNameConstants.USERNAME_VALIDATION_TEXT}} </div>
        </v-flex>
        <v-flex class="action__btn">
            <v-btn class="primary_btn transparent small" id="cancel_btn" @click="cancel()" data-qe-id="changeUserName_cancelBtn">
                {{ changeUserNameConstants.CANCEL }}
            </v-btn>
            <v-btn
                id="submit_username_change_btn"
                data-qe-id="changeUserName_submitBtn"
                class="primary_btn small"
                @click="submit"
                :disabled='isDisabled || inValid || isSubmitting'>
                {{ changeUserNameConstants.SAVE }}
            </v-btn>
        </v-flex>
    </v-form>
</template>

<script>
  import { mapActions, mapGetters, mapMutations } from "vuex";
  import { storeAction } from "../../store/storeActions.constant";
  import { storeGetters } from "../../store/storeGetters.constant";
  import { storeMutation } from "../../store/storeMutations.constant";
  import {
    myAccountConstants,
    changeUserNameConstants,
  } from "./myaccount.constants.js";
  import ClickOutside from "vue-click-outside";

  export default {
    name: "ChangeUserName",
    data: () => ({
      myAccountConstants,
      changeUserNameConstants,
      newUserName: "",
      success: false,
      userExists: false,
      error: false,
      inValid: true,
      isSubmitting: false,
    }),
    props: {
      registerOnClose: {
        type: Function,
        required: true,
      },
    },
    created() {
      this.registerOnClose(() => this.whenClosed());
    },
    methods: {
      whenClosed() {
        this.newUserName = "";
        this.resetError();
      },
      cancel() {
        this.newUserName = "";
        this.resetError();
      },
      submit() {
        this.isSubmitting = true;
        this.changeUserName(this.newUserName)
          .then(() => {
            this.setProfileInformationUsername(this.newUserName);
            this.success = true;
            this.newUserName = "";
            this.isSubmitting = false;
          })
          .catch(() => {
            if (
              this.usernameResponse.message ===
              changeUserNameConstants.USERNAME_EXISTS
            ) {
              this.userExists = true;
              this.inValid = true;
              this.isSubmitting = false;
            } else {
              this.resetError();
              this.error = true;
              this.inValid = true;
              this.isSubmitting = false;
            }
          });
      },
      ...mapActions({
        changeUserName: `myAccount/${storeAction.changeUserName}`,
      }),
      ...mapMutations({
        setProfileInformationUsername: `myAccount/${storeMutation.setProfileInformationUsername}`,
      }),
      resetError() {
        this.error = false;
        this.success = false;
        this.userExists = false;
        this.inValid = false;
      },
      isValidUserName($event) {
        if ($event.charCode === 0) {
          return true;
        }
        if (this.newUserName.length >= 64) {
          $event.preventDefault();
          return true;
        }
        if ($event.charCode >= 48 && $event.charCode <= 57) {
          return true;
        }
        if ($event.charCode >= 65 && $event.charCode <= 90) {
          return true;
        }
        if ($event.charCode >= 97 && $event.charCode <= 122) {
          return true;
        }
        if ($event.charCode === 95) {
          return true;
        }
        $event.preventDefault();
      },
      isPasted($event) {
        let str = "";
        this.text = $event.clipboardData.getData("text");
        if (this.newUserName.length + this.text.length >= 64) {
          $event.preventDefault();
          return true;
        }
        str = this.text.replace(/[^a-zA-Z0-9_]/g, "");
        this.newUserName += str;
        $event.preventDefault();
        return true;
      },
      none() {
        this.newUserName = "";
        this.resetError();
      },
    },
    computed: {
      ...mapGetters({
        profileInformation: `myAccount/${storeGetters.profileInformation}`,
        usernameResponse: `myAccount/${storeGetters.usernameResponse}`,
      }),
      isStrong() {
        return this.newUserName.length >= changeUserNameConstants.THREE &&
          this.newUserName.length <= changeUserNameConstants.SIXTY_FOUR
          ? "criteria__matched"
          : "criteria__notmatched";
      },
      isDisabled() {
        return !(
          this.newUserName.length >= changeUserNameConstants.THREE &&
          this.newUserName.length <= changeUserNameConstants.SIXTY_FOUR
        );
      },
      counter() {
        return this.newUserName.length;
      },
      validationError() {
        return this.userExists || this.error ? "text-color" : "";
      },
    },
    directives: {
      ClickOutside,
    },
  };
</script>

<style lang="scss" scoped>
  @import "../../common/styles/_colors.scss";
  @import "../../common/styles/_responsive.scss";

  .change-username {
    font-size: 12px;
    line-height: 24px;
    text-transform: initial;
    color: $ypo-blue;
    line-height: 24px;
    padding-top: 4px;
    font-size: 14px;
    font-weight: bold;
  }

  small {
    font-size: 12px;
    display: block;
    color: $ypo-dark-background-gray;
    font-weight: 400;
    text-transform: initial;
  }

  .new-username {
    box-sizing: border-box;
    padding: 0px;
  }

  .username-label {
    font-size: 12px;
    color: $ypo-cta;
    font-weight: 600;
  }

  .criteria {
    &__matched {
      color: $ypo-green;
    }

    &__notmatched {
      color: $ypo-gray;
    }
  }

  .warning-text {
    color: $ypo-dark-gray;
    font-size: 12px;
    line-height: 14px;
    margin-bottom: 25px;
    text-transform: initial;
    margin-top: 5px;
  }

  .error-text {
    color: $ypo-red;
    font-size: 12px;
    letter-spacing: 0.1px;
    text-transform: initial;
    margin-top: 5px;
    line-height: 17px;
  }

  .icons__block {
    position: relative;

    .value {
      position: absolute;
      top: 0;
      font-size: 14px;
      left: 10px;
    }

    i {
      font-size: 20px !important;
      position: absolute;
      margin: 18px 0px 0px 5px;
    }
  }

  .alert__box {
    &__success {
      background: $ypo-gold;
      color: $white;
      position: relative;
      padding: 10px 10px 10px 45px;
      font-size: 12px;
      text-transform: initial;
      line-height: normal;

      i {
        font-size: 20px !important;
        color: $white !important;
        opacity: 1 !important;
        position: absolute;
        left: 5px;
        top: 0;
        bottom: 0;
      }
    }

    &__failure {
      background: $ypo-red;
      color: $white;
      position: relative;
      padding: 10px 10px 10px 45px;
      font-size: 12px;
      text-transform: initial;
      line-height: normal;

      i {
        font-size: 20px !important;
        color: $white !important;
        opacity: 1 !important;
        position: absolute;
        left: 5px;
        top: 0;
        bottom: 0;
      }
    }
  }

  .action__btn {
    border-bottom: 1px solid rgba($ypo-cta, 0.2);
    flex: auto;
    width: auto;
    max-width: initial;
    text-align: right;
    padding: 10px;
    margin: 0 -30px;

    .v-btn {
      margin: 0 0 0 10px !important;
      height: 30px !important;
    }
  }

  .cursor {
    cursor: default;
  }

  .text-color {
    color: $ypo-red;
  }

  .truncate {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    color: $ypo_blue;
    letter-spacing: 0.09px;
    margin-top: 5px;
  }

  .truncate:hover {
    text-overflow: clip;
    white-space: normal;
    word-break: break-all;
  }
</style>
